var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.0546C21.5 7.05337 17.4711 3 12.5 3C7.52891 3 3.5 7.05337 3.5 12.0546C3.5 16.5745 6.78922 20.3205 11.0945 21V14.6741H8.81106V12.0546H11.0945V10.0601C11.0945 7.7926 12.4357 6.53768 14.4923 6.53768C15.4784 6.53768 16.5092 6.7163 16.5092 6.7163V8.94388H15.3751C14.2557 8.94388 13.9105 9.64349 13.9105 10.358V12.0546H16.4059L16.0065 14.6741H13.9105V21C18.2108 20.3205 21.5 16.5745 21.5 12.0546Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e14139edf8396406d1c8005bee54fef8.svg";
export { ForwardRef as ReactComponent };